module.exports = __webpack_public_path__ + "static/media/3.da7397f1.jpg";